import styled, { css } from 'styled-components';

export const StyledNewLabel = styled.span`
  font-size: var(--xxsmall-font-size);
  font-weight: 500;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: var(--blue-opacity);
  text-decoration-thickness: 13.5%;
  text-underline-offset: 25%;
  text-underline-position: from-font;
  text-transform: uppercase;
`;

export const browseCardBox = css`
  width: 264px;
  height: 243px;
  border: 1px solid var(--gray-medium);
  border-radius: var(--box-medium-border-radius);
`;
